import styled from "styled-components";

export const FormContainer = styled.div`
  width: 90%;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

export const FormHeader = styled.h3`
  text-align: center;
  margin-bottom: 20px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;

  label {
    font-weight: bold;
    margin-bottom: 5px;
  }

  input,
  select {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
`;

export const SubmitButton = styled.button`
  width: 90%;
  padding: 10px;
  background-color: #595959;
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #404040;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

export const Message = styled.p`
  text-align: center;
  color: ${(props) => (props.isError ? "#1a1a1a" : "#595959")};
  margin-top: 10px;
`;

export const ValidationError = styled.span`
  color: #1a1a1a;
  font-size: 12px;
  margin-top: 5px;
`;
